/* Barista You – Premium Layer JS: Scroll-Reveals, Parallax, Header-Scroll-State */
(function () {
  document.documentElement.classList.add('pr-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header Scroll-State ---------- */
  var scrollTicking = false;

  function updateScrollState() {
    document.documentElement.classList.toggle('pr-scrolled', window.scrollY > 24);
    scrollTicking = false;
  }

  function onScrollState() {
    if (!scrollTicking) {
      window.requestAnimationFrame(updateScrollState);
      scrollTicking = true;
    }
  }

  window.addEventListener('scroll', onScrollState, { passive: true });
  updateScrollState();

  /* ---------- Scroll Reveals ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.pr-reveal:not(.pr-visible)');

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pr-visible'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pr-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax ---------- */
  var parallaxEls = [];

  function collectParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-pr-parallax]'));
  }

  var ticking = false;

  function updateParallax() {
    for (var i = 0; i < parallaxEls.length; i++) {
      var el = parallaxEls[i];
      var rect = el.getBoundingClientRect();

      if (rect.bottom < 0 || rect.top > window.innerHeight) continue;

      var speed = parseFloat(el.getAttribute('data-pr-parallax')) || 0.12;
      var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -speed;
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.12)';
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  function initParallax() {
    collectParallax();
    if (!parallaxEls.length || reduce) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateParallax();
  }

  function initAll() {
    initReveals();
    initParallax();
    updateScrollState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme-Editor Support */
  document.addEventListener('shopify:section:load', initAll);
})();
